import { createFileRoute } from '@tanstack/react-router'

import { analyzerInsightsUsersSearchSchema } from '@/pages/analyzer-insights/users-search'

export const Route = createFileRoute('/_layout/analyzer-insights/users')({
  validateSearch: analyzerInsightsUsersSearchSchema,
})
